import React, { useEffect } from 'react';
import WorkingHoursInfo from './WorkingHoursInfo';
import ContentPageLayout from './ContentPageLayout';

const WorkingHoursPage: React.FC = () => {
    useEffect(() => {
        document.title = 'Working Hours - DeliFeed';
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'Check DeliFeed opening hours and delivery times. Fresh Mediterranean food delivered from Upper Cambourne to your door.');
        }
    }, []);

    return (
        <ContentPageLayout title="Working Hours">
            <WorkingHoursInfo />
        </ContentPageLayout>
    );
};

export default WorkingHoursPage;
